class ComparisonSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.overlay = null;
    this.divider = null;
    this.isRTL = document.documentElement.dir === 'rtl';
    this.isDragging = false;
  }

  connectedCallback() {
    // Find elements after the component is fully in the DOM
    this.slider = this.querySelector('.comparison-slider__input');
    this.overlay = this.querySelector('.comparison-slider__overlay');
    this.divider = this.querySelector('.comparison-slider__divider');

    if (!this.slider || !this.overlay || !this.divider) {
      console.error('Comparison Slider Component: Missing required elements.');
      return;
    }

    // Set initial position from the slider's default value
    this.updateSlider(this.slider.value);

    // Add ALL the event listeners we need
    this.slider.addEventListener('input', (e) => {
      this.updateSlider(e.target.value);
    });

    this.slider.addEventListener('change', (e) => {
      this.updateSlider(e.target.value);
    });

    // Add mouse events for direct interaction
    this.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.addEventListener('touchstart', this.handleTouchStart.bind(this));
    
    // Global mouse/touch events
    document.addEventListener('mousemove', this.handleMouseMove.bind(this));
    document.addEventListener('mouseup', this.handleMouseUp.bind(this));
    document.addEventListener('touchmove', this.handleTouchMove.bind(this));
    document.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  handleMouseDown(e) {
    this.isDragging = true;
    this.classList.add('dragging');
    this.updateFromEvent(e);
  }

  handleTouchStart(e) {
    this.isDragging = true;
    this.classList.add('dragging');
    this.updateFromEvent(e.touches[0]);
  }

  handleMouseMove(e) {
    if (!this.isDragging) return;
    this.updateFromEvent(e);
  }

  handleTouchMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    this.updateFromEvent(e.touches[0]);
  }

  handleMouseUp() {
    this.isDragging = false;
    this.classList.remove('dragging');
  }

  handleTouchEnd() {
    this.isDragging = false;
    this.classList.remove('dragging');
  }

  updateFromEvent(e) {
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    let percentage = (x / rect.width) * 100;
    percentage = Math.max(0, Math.min(100, percentage));
    
    this.slider.value = percentage;
    this.updateSlider(percentage);
  }

  updateSlider(value) {
    const percentage = parseFloat(value);

    // For handle position: invert so handle moves in correct direction
    const handlePosition = 100 - percentage;
    
    // For overlay width: use direct percentage 
    // Moving right (higher %) = less overlay (more after image shows)
    // Moving left (lower %) = more overlay (more before image shows)
    const overlayWidth = percentage;

    // Apply the overlay width and handle position
    if (this.overlay) {
      this.overlay.style.width = `${overlayWidth}%`;
    }
    if (this.divider) {
      this.divider.style.left = `${handlePosition}%`;
    }
  }
}

customElements.define('before-after-slider', ComparisonSliderComponent);
